// src/components/Legion.jsx
import { useEffect, useRef } from 'react';
import { useGsapContext } from '../hooks/useGsapContext';
import { gsap, ScrollTrigger } from '../lib/gsap/setupGsap';

export default function Legion() {
  const rootRef = useRef(null);
  const { ctx } = useGsapContext();

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const kicker = root.querySelector('.kicker');
    const title  = root.querySelector('.legion__title'); // ahora sí: también aparece con scroll
    const lead   = root.querySelector('.legion__lead');

    ctx.current.add(() => {
      // Estados iniciales inline para que se note el reveal aunque el CSS no tenga “hidden”
      if (kicker) gsap.set(kicker, { opacity: 0, y: 12, scale: 0.985, filter: 'blur(2px)' });
      if (title)  gsap.set(title,  { opacity: 0, y: 12, scale: 0.99,  filter: 'blur(2px)' });
      if (lead)   gsap.set(lead,   { opacity: 0, y: 14, scale: 0.985, filter: 'blur(2px)' });

      // Kicker — sutil, ligado al scroll
      if (kicker) {
        gsap.fromTo(
          kicker,
          { opacity: 0, y: 12, scale: 0.985, filter: 'blur(2px)' },
          {
            opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
            ease: 'power2.out',
            scrollTrigger: {
              trigger: kicker,           // cada elemento usa su propio trigger
              start: 'top 90%',
              end:   'top 70%',
              scrub: 0.35,
              invalidateOnRefresh: true,
              // markers: true,
            },
            immediateRender: false,
          }
        );
      }

      // Título — efecto igual de sutil (no modifico márgenes ni layout)
      if (title) {
        gsap.fromTo(
          title,
          { opacity: 0, y: 12, scale: 0.99, filter: 'blur(2px)' },
          {
            opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
            ease: 'power2.out',
            scrollTrigger: {
              trigger: title,
              start: 'top 88%',
              end:   'top 68%',
              scrub: 0.35,
              invalidateOnRefresh: true,
            },
            immediateRender: false,
          }
        );
      }

      // Lead — un poquito después para escalonar la lectura
      if (lead) {
        gsap.fromTo(
          lead,
          { opacity: 0, y: 14, scale: 0.985, filter: 'blur(2px)' },
          {
            opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
            ease: 'power2.out',
            scrollTrigger: {
              trigger: lead,
              start: 'top 86%',
              end:   'top 66%',
              scrub: 0.35,
              invalidateOnRefresh: true,
            },
            immediateRender: false,
          }
        );
      }

      ScrollTrigger.refresh();
    });
  }, [ctx]);

  return (
    <section ref={rootRef} id="legion" className="legion" aria-label="Comunidad M85">
      <div className="legion__content">
        <p className="kicker">No vendemos trailers</p>
        <h2 className="legion__title">
          Te invitamos a una legión de<br />nómadas modernos
        </h2>
        <p className="legion__lead">
          Ser dueño de un M85 es más que tener un tráiler; es tu acceso a la Legión
          Outlander. Una comunidad exclusiva con acceso a expediciones, mapas y un
          espacio para compartir experiencias.
        </p>
      </div>
    </section>
  );
}
